<div fxLayout="row">
  <div fxLayout="column" fxLayoutAlign="start" fxFlex="90">
    <h2 style="margin: 0; padding: 0;">แก้ไขบุคคล</h2>
  </div>
  <div fxLayout="column" fxFlex="10">
    <button mat-raised-button color="primary" (click)="onClose()">
      <span>ปิด</span>
    </button>
  </div>
</div>
<mat-form-field style="width: 100%;">
  <input matInput (keyup)="applyFilter($event.target.value)" placeholder="ค้นหา">
</mat-form-field>

<mat-table style="max-height: 400px; overflow-y: auto;" #table [dataSource]="tableSource" matSort [@animateStagger]="{value:'50'}" fusePerfectScrollbar>
  <ng-container matColumnDef="citizenId">
    <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>
      เลขบัตรประชาชน
    </mat-header-cell>
    <mat-cell *matCellDef="let model" fxHide fxShow.gt-sm>
      {{ model.citizenId }}
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>
      ชื่อ
    </mat-header-cell>
    <mat-cell *matCellDef="let model" fxHide fxShow.gt-sm>
      {{ model.firstName }} {{ model.lastName }}
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="position">
    <mat-header-cell fxFlex="150px" *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>
      ตำแหน่ง
    </mat-header-cell>
    <mat-cell fxFlex="150px" *matCellDef="let model" fxHide fxShow.gt-sm>
      {{ model.position }}
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="action">
    <mat-header-cell fxFlex="100px" *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>

    </mat-header-cell>
    <mat-cell fxFlex="100px" *matCellDef="let model" fxHide fxShow.gt-sm>
      <button mat-raised-button color="accent" style="width: 100%;" (click)="onSelected(model)">
        เลือก
      </button>
    </mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

  <mat-row *matRowDef="let model; columns: displayedColumns;" matRipple>
  </mat-row>
</mat-table>

<mat-paginator #paginator [length]="dataSource?.model?.length" [pageIndex]="0" [pageSize]="5"
               [pageSizeOptions]="[5, 10, 25, 100]">
</mat-paginator>
